import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-1, picture, image, cam"><path fillRule="evenodd" clipRule="evenodd" d="M8.87596 3.33397C9.01506 3.12533 9.24924 3 9.5 3H14.5C14.7508 3 14.9849 3.12533 15.124 3.33397L16.9014 6H21.25C21.6642 6 22 6.33579 22 6.75V20.25C22 20.6642 21.6642 21 21.25 21H2.75C2.33579 21 2 20.6642 2 20.25V6.75C2 6.33579 2.33579 6 2.75 6H7.09861L8.87596 3.33397ZM12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCamera1;
